import React from 'react'

interface IconProps {
  color?: string
  size?: number
  className?: string
  style?: React.CSSProperties
}

const originalWidth = 15
const originalHeight = 17
const aspectRatio = originalHeight / originalWidth // Maintains the original SVG aspect ratio (width/height)

export const CopyFilled: React.FC<IconProps> = ({
  color = '#fff',
  size = originalWidth,
  className,
  style,
  ...rest
}) => (
  <svg
    width={size}
    height={size * aspectRatio}
    viewBox="0 0 15 17"
    fill="none"
    className={className}
    style={style}
    {...rest}
  >
    <path
      d="M3 2.5h6.5a4 4 0 014 4v6.292A2.5 2.5 0 0015 10.5v-8A2.5 2.5 0 0012.5 0h-7A2.5 2.5 0 003 2.5z"
      fill={color || '#fff'}
      fillOpacity={0.6}
    />
    <path
      d="M0 6.5A2.5 2.5 0 012.5 4h7A2.5 2.5 0 0112 6.5v8A2.5 2.5 0 019.5 17h-7A2.5 2.5 0 010 14.5v-8z"
      fill={color || '#fff'}
    />
  </svg>
)
